<template>
    <div class="content">
        <div class="row">
            <div class="col-sm-6">
                <h1>Raportin tiedot</h1>
            </div>
            <div class="col-md-6 text-right">

                <button v-if="!isGeneratingPdf" :disabled="!buttonsEnabled" class="btn btn-success" v-on:click="generatePdf">PDF</button>
                <hollow-dots-spinner v-else class="pdfLoadingIndicator"
                        :animation-duration="1000"
                        :dot-size="12"
                        :dots-num="3"
                        color="red"
                />

                <button class="btn btn-success" :disabled="!buttonsEnabled" v-on:click="generateCSV()">CSV</button>
                <button class="btn btn-success" :disabled="!buttonsEnabled" v-on:click="generateExcel()">Excel</button>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-12">
                <label>Alkaen <md-icon>date_range</md-icon></label>
                <datepicker v-model="combinedTimes.start" :format="customFormat"></datepicker>
                &nbsp;
                <label>Saakka <md-icon>date_range</md-icon></label>
                <datepicker v-model="combinedTimes.end" :format="customFormat"></datepicker>
                &nbsp;
                <div class="settings">
                    <label><md-icon>settings</md-icon></label>


                    <!--div class="setting">
                        <label for="small-charts-setting">Pienet kuvaajat: </label>
                        <input type="checkbox" id="small-charts-setting" v-on:click="toggleSmallCharts()" v-model="smallCharts">
                    </div-->

                    <div class="setting">
                        <label for="include-table-for-pdf">Ota taulukko pdf-raportille: </label>
                        <input type="checkbox" id="include-table-for-pdf" v-on:click="toggleIncludeTableInPdf()" v-model="includeTableInPdf">
                    </div>

                    <div class="setting">
                        <label for="show-value-range-sliders">Näytä arvorajojen suodattimet: </label>
                        <input type="checkbox" id="show-value-range-sliders" v-on:click="toggleShowValueRangeSliders()" v-model="showRangeSliders">
                    </div>

                    <div class="setting">
                        <label for="start-graph-from-zero">Aloita kuvaajat nollasta: </label>
                        <input type="checkbox" id="start-graph-from-zero" v-on:click="toggleStartGraphFromZero()" v-model="startGraphFromZero">
                    </div>

                    <div class="setting">
                        <label for="show-combination-charts">Näytä yhdistelmäkuvaaja: </label>
                        <input type="checkbox" id="show-combination-charts" v-on:click="toggleShowCombinationCharts()" v-model="showCombinationCharts">
                    </div>

                    <div class="setting">
                        <label for="show-activity">Näytä valittujen laitteiden aktiivisuus: </label>
                        <input type="checkbox" id="show-activity" v-on:click="toggleShowActivity()" v-model="showActivity">
                    </div>
                </div>
            </div>
        </div>

        <ActivityTimeline
                v-if="showActivity"
                :devices="selectedDevices"
                :start="combinedTimes.start"
                :end="combinedTimes.end"
        />

        <br/>
        <b-tabs>
            <b-tab v-for="(device, index) in selectedDevices"
               :title="device.name"
               :key="device.id"
               v-on:click="loadDeviceObservations(device); refreshSlider(index)"
               :style="{color: color}"
            >
              <DeviceData
                      ref="deviceDataRef"
                      :deviceName="device.name"
                      :deviceId="device.id"
                      :chartsTagId="getChartsTagId(device.id)"
                      :tableTagId="getTableTagId(device.id)"
                      :extraTextFieldId="getExtraTextFieldId(device.id)"
                      :parent_times="combinedTimes"
                      :parentShowSmallCharts="smallCharts"
                      :parentStartGraphFromZero="startGraphFromZero"
                      :parentSetContentToBeAddedToBillingPdf="setContentToBeAddedToBillingPdf"
                      :parentCreateInitialBillingPdf="createInitialBillingPdf"
              />
            </b-tab>
        </b-tabs>

    </div>
</template>

<script>
    import axios from 'axios';
    import EventBus from '../../service/EventBus';
    import { default as DeviceData } from './DeviceData';
    import { default as ActivityTimeline } from './ActivityTimeline';
    import Datepicker from 'vuejs-datepicker';
    import { FoxEnvs } from '../../service/foxeriot_environments';
    import { HollowDotsSpinner } from 'epic-spinners'
    import ExcelService from '../../service/ExcelService'

    import html2canvas from 'html2canvas';
    import jsPDF from 'jspdf';
    import autoTable from 'jspdf-autotable';

    export default {
        name: 'ReportView',
        components: {
            ActivityTimeline,
            DeviceData,
            Datepicker,
            HollowDotsSpinner
        },
        data() {
            return {
                generatingPdf: false,
                combinedTimes: {
                    start: new Date(new Date().setHours(0,0)),
                    end: new Date(new Date().setHours(23,59))
                },
                currentSelectedDeviceId: null,
                currentSelectedDeviceName: null,
                startDate: new Date(new Date().setHours(0,0)),
                endDate: new Date(new Date().setHours(23,59)),
                datatable: false,
                temp_interval: false,
                extraTextYMargin: 0,

                pdfElements: [],
                pageHeight: null,
                pdfInitialMarginTop: 60,
                smallCharts: false,
                includeTableInPdf: false,
                showRangeSliders: false,
                startGraphFromZero: true,
                showCombinationCharts: false,
                showActivity: false,
                testVariable: 0,
            }
        },
        methods: {
            exportCSV: function (csvContent, deviceName) {

                // The download function takes a CSV string, the filename and mimeType as parameters
                // Scroll/look down at the bottom of this snippet to see how download is called
                var download = function(content, fileName, mimeType) {
                    var a = document.createElement('a');
                    mimeType = mimeType || 'application/octet-stream';

                    if (navigator.msSaveBlob) { // IE10
                        navigator.msSaveBlob(new Blob([content], {
                            type: mimeType
                        }), fileName);
                    } else if (URL && 'download' in a) { //html5 A[download]
                        a.href = URL.createObjectURL(new Blob([content], {
                            type: mimeType
                        }));
                        a.setAttribute('download', fileName);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                    }
                };
                download(csvContent, deviceName+'.csv', 'text/csv;encoding:utf-8');
            },
            removeSpecial: function (s){
                s = s.replace(/[^a-zA-Z0-9]/g, '');
                return s;
            },
            customFormat: function(date) {
                let options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                };
                return date.toLocaleDateString('fi-FI', options);
            },
            toggleSmallCharts: function() {
                this.$store.dispatch('showChartsSmall', !this.smallCharts).then(() => {})
            },
            toggleIncludeTableInPdf: function() {
                this.$store.dispatch('includeTableInPdf', !this.includeTableInPdf).then(() => {})
            },
            toggleShowValueRangeSliders: function() {
                this.$store.dispatch('showRangeSliders', !this.showRangeSliders).then(() => {})
            },
            toggleStartGraphFromZero: function() {
                this.$store.dispatch('startGraphFromZero', !this.startGraphFromZero).then(() => {})
            },
            toggleShowCombinationCharts: function() {
                this.$store.dispatch('showCombinationCharts', !this.showCombinationCharts).then(() => {})
            },
            toggleShowActivity: function() {
                this.$store.dispatch('showActivity', !this.showActivity).then(() => {})
            },
            refreshSlider(index) {
                if (this.$refs.deviceDataRef) {
                    if (typeof this.$refs.deviceDataRef[index].refreshSliders === 'function') {
                        this.$refs.deviceDataRef[index].refreshSliders()
                    }
                }
            },
            loadDeviceObservations: function(device) {
                this.currentSelectedDeviceId = device.id;
                this.currentSelectedDeviceName = device.name;
                let times = this.getConvertedTimes();
            },
            currentSelectedHasObservations() {
                let observationsFromStore = this.$store.getters.devicesObservations
                return this.currentSelectedDeviceId in observationsFromStore
            },
            generatePdf: function() {
                this.generatingPdf = true

                let pdf = this.createInitialPdf()
                this.setSliderToBeAddedToPdf()
                this.setCombinationChartToBeAddedToPdf()
                this.setGraphsHeaderToBeAddedToPdf()
                this.setChartsToBeAddedToPdf()

                this.formPdfReport(pdf)
            },

            createInitialPdf() {
                this.datatable.page.len( -1 ).draw();
                let pdf = new jsPDF('p', 'mm', 'a4');
                this.setHeader(pdf)
                this.marginTop = this.pdfInitialMarginTop;
                return pdf
            },

            createInitialBillingPdf() {
                let pdf = new jsPDF('p', 'mm', 'a4');
                this.marginTop = 20;
                return pdf
            },
            setSliderToBeAddedToPdf() {
                let showSliders = this.$store.getters.showRangeSliders
                if (showSliders) {
                    let elementToImage = document.querySelector("#" + 'slider' + this.currentSelectedDeviceId)
                    this.pdfElements.push(elementToImage)
                }
            },

            setCombinationChartToBeAddedToPdf() {
                let showCombinationChart = this.$store.getters.showCombinationCharts
                if (showCombinationChart) {
                    let combinationChartHeaderElement = document.querySelector("#combination-chart-" + this.currentSelectedDeviceId + 'header')
                    this.pdfElements.push(combinationChartHeaderElement)
                    let combinationChartChartElement = document.querySelector("#combination-chart-" + this.currentSelectedDeviceId)
                    this.pdfElements.push(combinationChartChartElement)
                }
            },

            setGraphsHeaderToBeAddedToPdf() {
                let chartsTagId = this.getChartsTagId(this.currentSelectedDeviceId)
                let elementToImage = document.querySelector("#" + chartsTagId + 'header')
                if (elementToImage) {
                    this.pdfElements.push(elementToImage)
                }
            },

            setChartsToBeAddedToPdf() {
                let chartsTagId = this.getChartsTagId(this.currentSelectedDeviceId)
                let showSmallCharts = this.$store.getters.showSmallCharts
                if (showSmallCharts) {
                    let elementToImage = document.querySelector("#" + chartsTagId)
                    this.pdfElements.push(elementToImage)
                } else {
                    const container = document.querySelector("#" + chartsTagId)
                    const chartsNodeList = container.querySelectorAll("div.graph");
                    let graphs = [].slice.call(chartsNodeList)
                    this.pdfElements = this.pdfElements.concat(graphs)
                }
            },

            setContentToBeAddedToBillingPdf(billingformId, pdf, deviceName){

                const container = document.querySelector("#" + billingformId)
                const chartsNodeList = container.querySelectorAll("div.billingContent")
                let graphs = [].slice.call(chartsNodeList)

                this.pdfElements = this.pdfElements.concat(graphs)
                let startTime = this.customFormat(this.combinedTimes.start);
                let endTime = this.customFormat(this.combinedTimes.end);

                pdf.setFontSize(12);
                pdf.setFontStyle('normal');

                if(document.getElementById(billingformId)) {
                    let fields = [];
                    fields.push({type: "heading", name: "billing-title"});
                    fields.push({type: "heading", name: "billing-location"});

                    let startHeight = 0

                    let headingRows = fields.filter(obj => {
                        return obj.type === "heading"
                    })

                    let extraMarginFromLeftAndRight = 10;
                    let maxTextWidth = pdf.internal.pageSize.getWidth() - extraMarginFromLeftAndRight * 2;

                    for (let i in headingRows) {
                        let val = document.getElementById(billingformId).getElementsByClassName(headingRows[i].name)[0].value;
                        if (val != '') {
                            if(fields[i].name == "billing-title"){
                                val += " " +startTime + " - " + endTime + " "
                            }
                            let splitVal = pdf.splitTextToSize(val, maxTextWidth);
                            this.extraTextYMargin = ((splitVal.length + 0.5) * 12 / 2.8346438836889) + 6;
                            let startY = 40+startHeight;
                            pdf.text(extraMarginFromLeftAndRight, startY, splitVal);
                            startHeight += 8;
                        }
                    }
                    startHeight += 8;

                    pdf.text(extraMarginFromLeftAndRight, 40+startHeight, "Mittarin lukema "+startTime)
                    let startValue = this.toBillingNumber(document.getElementById(billingformId).getElementsByClassName("billing-start-value")[0].value)
                    pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, startValue)
                    startHeight += 8

                    pdf.text(extraMarginFromLeftAndRight, 40+startHeight, "Mittarin lukema "+endTime);
                    let endValue = this.toBillingNumber(document.getElementById(billingformId).getElementsByClassName("billing-end-value")[0].value)
                    pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, endValue)
                    startHeight += 8

                    let unit = document.getElementById(billingformId).getElementsByClassName("billing-unit")[0].value
                    let difference = parseFloat(document.getElementById(billingformId).getElementsByClassName("billing-end-value")[0].value)-parseFloat(document.getElementById(billingformId).getElementsByClassName("billing-start-value")[0].value)
                    if(difference >= 0){
                        pdf.text(extraMarginFromLeftAndRight, 40+startHeight, unit)
                        pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, String(this.toBillingNumber(difference)))
                        startHeight += 8
                    }

                    let unitPrice = parseFloat(document.getElementById(billingformId).getElementsByClassName("billing-price-per-unit")[0].value)
                    pdf.text(extraMarginFromLeftAndRight, 40+startHeight, "Hinta per "+unit);
                    pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, this.toBillingNumber(unitPrice))
                    startHeight += 8

                    if(difference >= 0 && unitPrice > 0){
                        let cost = difference*unitPrice
                        pdf.text(extraMarginFromLeftAndRight, 40+startHeight, "Kustannus ");
                        pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, this.toBillingNumber(cost))
                        startHeight += 8

                        if(document.getElementById(billingformId).getElementsByClassName("billing-tax-name")[0].value != null && document.getElementById(billingformId).getElementsByClassName("billing-tax")[0].value != null){
                            pdf.text(extraMarginFromLeftAndRight, 40+startHeight, document.getElementById(billingformId).getElementsByClassName("billing-tax-name")[0].value)
                            let taxCost = parseFloat(document.getElementById(billingformId).getElementsByClassName("billing-tax")[0].value)*0.01*cost
                            pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, this.toBillingNumber(taxCost))
                            startHeight += 8
                            pdf.text(extraMarginFromLeftAndRight, 40+startHeight, "Yhteensä");
                            let totalCost = taxCost+cost;
                            pdf.text(extraMarginFromLeftAndRight+100, 40+startHeight, this.toBillingNumber(totalCost))
                            startHeight += 8
                        }
                    }

                }

                this.pageHeight = pdf.internal.pageSize.getHeight()
                this.getGraphImageForPdf(pdf).then(graphImage => {
                    let marginLeft = 10

                    pdf.addImage(
                            graphImage.image,
                            'JPEG',
                            marginLeft,
                            this.marginTop,
                            graphImage.imgWidth,
                            graphImage.imgHeight
                    );

                    let littleMoreSpace = 5
                    this.marginTop = this.marginTop + littleMoreSpace + graphImage.imgHeight

                })
                .then(() => {
                    if (this.pdfElements.length !== 0) {
                        this.formPdfReport(pdf);
                    } else {
                        pdf = this.addExtraTextFieldToPdf(pdf);
                        let addTableToPdf = this.$store.getters.includeTableInPdf;
                        if (addTableToPdf) {
                            pdf = this.addTableToPdf(pdf);
                        }
                        pdf.save(this.currentSelectedDeviceName + '.pdf');
                        this.temp_interval = setInterval(() => this.defaultTableSize(), 10);
                        this.generatingPdf = false
                    }
                })

            },
            toBillingNumber(number){

                let returnNumber = parseFloat(number)
                returnNumber = returnNumber.toFixed(2)
                returnNumber = returnNumber.replace(".", ",")
                return returnNumber
            },
            formPdfReport(pdf) {

                this.pageHeight = pdf.internal.pageSize.getHeight()
                this.getGraphImageForPdf(pdf)
                    .then(graphImage => {

                        let marginLeft = 10;

                        this.addNewPageIfThereIsNotEnoughSpace(pdf, graphImage.imgHeight)

                        pdf.addImage(
                            graphImage.image,
                            'JPEG',
                            marginLeft,
                            this.marginTop,
                            graphImage.imgWidth,
                            graphImage.imgHeight
                        );

                        let littleMoreSpace = 5
                        this.marginTop = this.marginTop + littleMoreSpace + graphImage.imgHeight

                    })
                    .then(() => {
                        if (this.pdfElements.length !== 0) {
                            this.formPdfReport(pdf);
                        } else {
                            this.offerPdf(pdf)
                        }
                    })

            },
            offerPdf(pdf) {
                pdf = this.addExtraTextFieldToPdf(pdf);
                let addTableToPdf = this.$store.getters.includeTableInPdf;
                if (addTableToPdf) {
                    pdf = this.addTableToPdf(pdf);
                }
                pdf = this.addPagenumbers(pdf);
                pdf.save(this.currentSelectedDeviceName + '.pdf');
                this.temp_interval = setInterval(() => this.defaultTableSize(), 10);
                this.generatingPdf = false
            },
            defaultTableSize(){
                if(this.datatable.page.len() != 10) {
                    this.datatable.page.len(10).draw();
                    clearInterval(this.temp_interval);
                    this.temp_interval = false;
                }
            },
            getChartsTagId(id) {
                return 'charts-' + id;
            },

            getTableTagId(id) {
                return 'table-' + id;
            },

            getExtraTextFieldId(id) {
                return 'extra-' + id;
            },

            getGraphImageForPdf(pdf) {
                let elementToImage = this.pdfElements.shift()
                return html2canvas(elementToImage)
                    .then(canvas => {
                        let graphImage = canvas.toDataURL("image/jpeg,1.0");

                        let imgWidth = pdf.internal.pageSize.getWidth() - 22;
                        let imgHeight = (imgWidth/canvas.width) * canvas.height

                        return {
                            image: graphImage,
                            imgHeight: imgHeight,
                            imgWidth: imgWidth,
                        };
                    });

            },

            addExtraTextFieldToPdf(pdf){

                let extraTagId = this.getExtraTextFieldId(this.currentSelectedDeviceId)
                if(document.getElementById(extraTagId)) {
                    let val = document.getElementById(extraTagId).value;
                    if (val != '') {
                        pdf.setFontSize(12);
                        pdf.setFontStyle('normal');

                        //let marginFromHeaderTop = 53;
                        let extraMarginFromLeftAndRight = 20;
                        let maxTextWidth = pdf.internal.pageSize.getWidth() - extraMarginFromLeftAndRight * 2;
                        let splitVal = pdf.splitTextToSize(val, maxTextWidth);

                        //"What is this?", you may ask. Let me explain
                        //Extra text margin   =  array.length (rows) +0.5 (because why not?) multiplied by font size (12)
                        //and divided using "points to millimeter" conversion and that is the exact number for it (yes, it is).
                        //Finally, add a bit extra margin between table and text.
                        this.extraTextYMargin = ((splitVal.length + 0.5) * 12 / 2.8346438836889) + 6;

                        this.addNewPageIfThereIsNotEnoughSpace(pdf, this.extraTextYMargin)
                        let startY = this.marginTop

                        pdf.text(extraMarginFromLeftAndRight, startY, splitVal);

                    }
                }

                return pdf;
            },

            addNewPageIfThereIsNotEnoughSpace(pdf, heightOfTheElementToAdd) {
                let moreSpaceToBottom = 15
                if ((this.pageHeight - moreSpaceToBottom - this.marginTop - heightOfTheElementToAdd) < 0) {
                    this.marginTop = this.pdfInitialMarginTop;
                    pdf.addPage()
                    this.setHeader(pdf)
                }

            },

            setHeader(pdf) {

                pdf.setFontSize(18);
                pdf.setTextColor(40);
                pdf.setFontStyle('normal');

                if (this.currentSelectedDeviceId === this.currentSelectedDeviceName) {
                    var nameData = this.currentSelectedDeviceId
                } else {
                    var nameData = this.currentSelectedDeviceId + ' ' + this.currentSelectedDeviceName;
                }

                let headerLeftMargin = 15

                pdf.text("Raportin tiedot | " + nameData, headerLeftMargin, 20);

                pdf.setFontSize(12);
                pdf.setTextColor(40);
                pdf.setFontStyle('normal');

                let extraDownFromHeader = 5;
                let extraMarginFromLeft = 6;

                let startTime = this.customFormat(this.combinedTimes.start);
                let endTime = this.customFormat(this.combinedTimes.end);
                let raportTakingTime = this.customFormat(new Date());

                pdf.text("Aikaväli: " + startTime + " - " + endTime,
                    headerLeftMargin + extraMarginFromLeft,
                    25 + extraDownFromHeader);
                pdf.text("Luotu: " + raportTakingTime,
                    headerLeftMargin + extraMarginFromLeft,
                    32 + extraDownFromHeader);
                pdf.text("Käyttäjä: " + this.$auth.userEmail.get(),
                    headerLeftMargin + extraMarginFromLeft,
                    39 + extraDownFromHeader);

                let bottomLineTopPosition = 34 + extraDownFromHeader + 10;

                pdf.setDrawColor(0);
                pdf.line(10, bottomLineTopPosition, 200, bottomLineTopPosition);
            },
            addTableToPdf(pdf) {

                let tableTagId = this.getTableTagId(this.currentSelectedDeviceId)
                let table = pdf.autoTableHtmlToJson(document.getElementById(tableTagId), true);

                //var that = this;
                let header = (data) => {
                    this.setHeader(pdf)
                };

                let marginFromHeaderTop = 53;
                let startYMargin = 15;

                let options = {
                    theme: 'grid',
                    styles: {
                        columnWidth: 'auto',
                        overflow: 'linebreak',
                    },
                    headerStyles: {
                        fillColor: 240,
                        textColor: 0,
                    },
                    columnStyles: {
                        // time column should be wide enough
                    },
                    addPageContent: header,
                    margin: {
                        top: marginFromHeaderTop
                    },
                    startY: this.marginTop + this.extraTextYMargin
                };

                let lastColumn = table.columns.length - 1; // column with time
                options.columnStyles[lastColumn] = {columnWidth: 35};

                pdf.autoTable(table.columns, table.data, options);
                return pdf;
            },

            addPagenumbers(pdf){
                pdf.setFontSize(10);

                var pageCount = pdf.internal.getNumberOfPages();
                for(let i = 0; i < pageCount; i++) {
                    pdf.setPage(i);
                    pdf.text(pdf.internal.pageSize.getWidth() - 16, 44, pdf.internal.getCurrentPageInfo().pageNumber + "/" + pageCount);
                }
                return pdf;
            },

            pad: function(number) {
                if (number < 10) {
                    return "0" + number
                } else {
                    return number
                }
            },

            convertDate: function(date) {
                let custom_date = this.customFormat(date);
                let res = custom_date.split(".");

                let padMonth = parseInt(res[1]);

                let padDay = parseInt(res[0]);

                let testDate = new Date(res[2], (padMonth - 1), (padDay), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
                testDate.setTime(testDate.getTime() + testDate.getTimezoneOffset() * 60 * 1000);

                let dds = testDate.getDate();
                let mms = testDate.getMonth() + 1;
                let yyyys = testDate.getFullYear();

                let hours = testDate.getHours();
                let mins = testDate.getMinutes();
                let secs = testDate.getSeconds();

                dds = this.pad(dds);
                mms = this.pad(mms);
                hours = this.pad(hours);
                mins = this.pad(mins);
                secs = this.pad(secs);

                var convertedDate = yyyys + '-'
                        + mms + '-'
                        + dds + 'T'
                        + hours + ':' + mins + ':' + secs + '.000Z';

                return convertedDate
            },
            readableDate: function (date) {
                let day = this.pad(date.getDate());
                let month = this.pad(date.getMonth() + 1);
                let year = this.pad(date.getFullYear());

                let hours = this.pad(date.getHours());
                let minutes = this.pad(date.getMinutes());

                return day + '.' + month + '.' + year + ' ' + hours + ':' + minutes;
            },
            getConvertedTimes: function() {
                let startDate = this.combinedTimes.start;
                let endDate = this.combinedTimes.end;

                let convertedStart = this.convertDate(startDate);
                let convertedEnd = this.convertDate(endDate);

                return {start: convertedStart, end: convertedEnd}
            },
            generateCSV: function() {
                return $('#table-'+this.currentSelectedDeviceId+'_wrapper .buttons-csv').click()
            },

            generateExcel: function() {
                let excelService = new ExcelService()
                let observationsFromStore = this.$store.getters.devicesObservations
                excelService.makeExcelFromDeviceData(observationsFromStore, this.currentSelectedDeviceId);
            },
        },

        computed: {
            buttonsEnabled() {
                return (this.$store.getters.observationsFetchedChange && this.currentSelectedHasObservations())
            },
            isGeneratingPdf: function() {
                return this.generatingPdf
            },
            color: function() {
                return this.$store.getters.sidetext;
            },
            selectedDevices: function() {
                //When new device is selected, there was a situation when device.id and device.name was not correctly updated
                //which then caused problems when downloading a PDF. This is supposed to fix that one.
                //According to my tests, this indeed looks like it solved it.
                //For some reason v-on:click fired when first device was selected, causing problems later on.
                var devices = this.$store.getters.devices;
                var arrayLength = devices.length;
                var returnToBeginning = true;

                //First of all, check if there's something in an array
                if(arrayLength > 0) {
                    //If we have already selected tab, check if it exists in array and stay on that page
                    for (var i = 0; i < arrayLength; i++) {
                        let device = devices[i];
                        if(device.id == this.currentSelectedDeviceId){
                            returnToBeginning = false;
                        }
                    }
                    if(returnToBeginning){
                        this.loadDeviceObservations(devices[0]); //In any other case, select 0th cell
                    }
                }

                return this.$store.getters.devices;
            }
        },
        mounted: function() {

            jQuery.fn.dataTableExt.afnFiltering.push(
                (settings, aData, iDataIndex) => {
                    let table_headers = [];
                    settings.aoHeader[0].forEach((v) => {
                       // console.log(v);
                        table_headers.push(v.cell.textContent)
                    })
                    let result = false;
                    let device_id = settings.sTableId.split("-")[1]
                    let filters = this.$store.getters.filters[device_id];

                    if(!filters) {
                        return true;
                    }

                    let filter_keys = Object.keys(filters);
                    if (filter_keys.length !== 0) {
                        filter_keys.some( (key) => {
                            let filter = filters[key];
                            let index = table_headers.indexOf(filter.name)
                            if (index < 0) {
                                return false;
                            }

                            let table_value = aData[index]
                            table_value = table_value.replace(',', '.');

                            switch (filter.operand) {
                                case "=":
                                    result = !( parseFloat(table_value) === parseFloat(filter.value) )
                                    break;
                                case ">":
                                    result = !( parseFloat(table_value) > parseFloat(filter.value) )
                                    break;
                                case "<":
                                    result = !( parseFloat(table_value) < parseFloat(filter.value) )
                                    break;
                                default:
                                    break;
                            }
                            return result;

                        })
                    }

                    return !result
                }
            )

            //Catch datatable and change paging when downloading PDF
            EventBus.$on('datatable', (e) => {
                this.datatable = e;
            });
        },
        watch: {
            'combinedTimes.start':  function (newval) {
                newval.setHours(0,0)
                this.combinedTimes.start = newval
            },
            'combinedTimes.end': function (newval) {
                newval.setHours(23,59)
                this.combinedTimes.end = newval
            },
        },
    }
</script>

<style scoped>
    label {
        font-weight: 600;
    }
    i {
        font-weight: 400;
    }
    .vdp-datepicker {
        display: inline-block;
    }
    div {
        background: white;
        text-align: left;
    }
    h2 {
        color: dimgray;
    }
    a {
        color: #dfdfdf;
    }
    .settings {
        background: #f1f1f1;
        display: inline-block;
        padding: 10px 12px 0px 12px;
        border-radius: 3px;
    }
    .setting {
        font-size: 0.8em;
        display: inline-block;
        background: #f1f1f1;
        margin-left: 22px;
    }
    .pdfLoadingIndicator {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/ReportView.vue